<div
  class="hot-toast-info-icon"
  [style.--info-primary]="theme()?.primary"
  [style.--info-secondary]="theme()?.secondary"
></div>
